import React from "react";
import MainHeader from "../../Components/Header/MainHeader";
import MainFooter from "../../Components/Footer/MainFooter";

// Where Pesapal's hosted checkout sends the browser back to after payment.
// Purely informational — the actual subscription confirmation happens
// server-side via the pesapalIPN Cloud Function, not this page, since Pesapal
// may redirect here before the IPN has finished processing.
export default function SubscribeComplete() {
  return (
    <>
      <MainHeader />
      <main className="max-w-2xl mx-auto px-4 py-16 text-center">
        <h1 className="text-2xl font-bold text-navy mb-3">Thanks!</h1>
        <p className="text-gray-600">
          We're confirming your payment now. Your subscription status will update in the
          Rekebisha app within a few minutes — you can close this page.
        </p>
      </main>
      <MainFooter />
    </>
  );
}
